import PropTypes from 'prop-types';

import { cymbioColors } from '../../../utils/colors';

export function DownloadReportIcon({ strokeColor = cymbioColors.analytics.pink, strokeWidth = 1 }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33406 14.1669V15.8336C3.33406 16.2756 3.50966 16.6995 3.82222 17.0121C4.13478 17.3247 4.5587 17.5003 5.00073 17.5003H15.0007C15.4428 17.5003 15.8667 17.3247 16.1792 17.0121C16.4918 16.6995 16.6674 16.2756 16.6674 15.8336V14.1669"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <path
        d="M5.83406 9.16693L10.0007 13.3336L14.1674 9.16693"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <path
        d="M9.99992 3.33344V13.3334"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

DownloadReportIcon.propTypes = {
  strokeColor: PropTypes.string,
  strokeWidth: PropTypes.number,
};
